import React from 'react'
import { Link } from 'react-router-dom'
import clsx from 'clsx'

import type { SoftwareListSchema } from 'openapi'
import { resizeImgUrl } from 'utils/resizeImgUrl'
import { SoftwareRoutePath } from 'router'
import { useCategory } from 'features/categories/hooks'

type Props = {
  software: SoftwareListSchema
  className?: string
  resizeWidth?: string
}

export const SoftwareItem = React.memo((props: Props) => {
  const { software, className, resizeWidth } = props

  const cover = resizeImgUrl(software.cover, resizeWidth ?? '600x')
  // const hasVersions = software.versions.length > 0
  // const isActive = software.enabled

  if (!software.category_id) throw new Error(`software.category_id is required: ${JSON.stringify(software)}`)

  const [category, categoryLoading] = useCategory(software.category_id)
  if (categoryLoading) return null

  if (!category) throw new Error(`category not found for software: ${JSON.stringify(software)}`)

  const link: string = SoftwareRoutePath({
    softwareId: software.id,
    categorySlug: category?.slug,
    vendorSlug: software.vendorSlug,
    softwareSlug: software.slug,
  })
  return (
    <div>
      <div
        className={clsx(
          'divide-y divide-gray-200 rounded text-black',
          className,
          'hover:',
          !(software.status === 'enabled') ? 'opacity-50' : null,
          // '[&_.card-text-block]:bg-slate-50 hover:[&_.card-text-block]:bg-white'
        )}
      >
        <Link to={link} draggable="false">
          <div
            className="bg-cover bg-center w-full h-32 flex-shrink-0 rounded relative"
            style={{ backgroundImage: `url(${cover})` }}
          />
          <div className="flex flex-col gap-y-1 p-2 w-full rounde1d-b card-text-block">
            <div className="text-sm font-medium">{software.name}</div>
            <div className="text-xs">by {software.vendor}</div>
            <div className="w-full ">
              {/*<div className="w-full">*/}
              {/*  {!hasVersions ? <SoftwareItemTag color="red">No versions</SoftwareItemTag> : null}*/}
              {/*  {!isActive ? <SoftwareItemTag color="gray">Not active</SoftwareItemTag> : null}*/}
              {/*</div>*/}
            </div>
          </div>
        </Link>
      </div>
    </div>
  )
})
